import { render, staticRenderFns } from "./SetArrestsButton.vue?vue&type=template&id=a09e3960&scoped=true&"
import script from "./SetArrestsButton.vue?vue&type=script&lang=ts&"
export * from "./SetArrestsButton.vue?vue&type=script&lang=ts&"
import style0 from "./SetArrestsButton.vue?vue&type=style&index=0&id=a09e3960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09e3960",
  null
  
)

export default component.exports